import { ReactNode } from 'react'
import { Flex } from '@npco/zeller-design-system'

interface Props {
  children: ReactNode | ReactNode[]
}

export const DashboardTopSection = ({ children }: Props) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      overflow="hidden"
      p={{ _: '90px 0 24px', XS: '106px 0 24px', MD: '40px 0 24px' }}
    >
      {children}
    </Flex>
  )
}
